module.exports = __webpack_public_path__ + "static/media/icon-edit-contour.50c1b882.svg";